import { TerraDrawRectangleMode, TerraDrawSelectMode } from 'terra-draw';

export type TerraDrawModeId = 'select' | 'rectangle';

export const DRAWING_MODE_BUTTONS: Array<{
  id: TerraDrawModeId;
  label: string;
}> = [{ id: 'rectangle', label: 'Draw Rectangle' }];

// Red color for all rectangles
const RECTANGLE_COLOR: `#${string}` = '#FF0000';

const createRectangleStyles = () => ({
  fillColor: RECTANGLE_COLOR,
  fillOpacity: 0.3,
  outlineColor: RECTANGLE_COLOR,
  outlineOpacity: 1,
  outlineWidth: 2,
});

// Styles for selected/editable rectangles in SelectMode
const createSelectModeStyles = () => ({
  selectedPolygonColor: RECTANGLE_COLOR,
  selectedPolygonFillOpacity: 0.3,
  selectedPolygonOutlineColor: RECTANGLE_COLOR,
  selectedPolygonOutlineOpacity: 1,
  selectedPolygonOutlineWidth: 2,
});

// Selection flags for editing user-drawn rectangles in Select mode
const RECTANGLE_SELECT_FLAGS = {
  feature: {
    draggable: false,
    rotateable: false,
    coordinates: {
      midpoints: false,
      draggable: false,
      deletable: false,
    },
  },
};

// Centralized mode factory to keep UI and TerraDraw configuration in sync.
// This configuration restricts drawing to rectangles only.
// - 'saved-rectangles' (RenderMode): Read-only display of existing saved regions
// - 'select' (SelectMode): Edit/delete user-drawn rectangles
// - 'rectangle' (RectangleMode): Draw new rectangles
export const createTerraDrawModes = () => [
  new TerraDrawSelectMode({
    modeName: 'select',
    styles: createSelectModeStyles(),
    flags: {
      rectangle: RECTANGLE_SELECT_FLAGS,
    },
  }),
  new TerraDrawRectangleMode({
    modeName: 'rectangle',
    drawInteraction: 'click-drag',
    styles: createRectangleStyles(),
  }),
];
